var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "el-row-line" },
        [
          _c("PageInfo"),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { float: "right" },
              attrs: { type: "primary" },
              on: { click: _vm.addRoleBtn },
            },
            [
              _c("i", { staticClass: "el-icon-circle-plus" }),
              _vm._v("\n      新建"),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "el-form",
                { attrs: { model: _vm.searchForm, inline: true } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择角色",
                          },
                          model: {
                            value: _vm.searchForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "name", $$v)
                            },
                            expression: "searchForm.name",
                          },
                        },
                        _vm._l(_vm.querySelectOptions, function (item, index) {
                          return _c(
                            "el-option",
                            {
                              key: index,
                              attrs: { label: item.name, value: item.name },
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            filterable: "",
                            placeholder: "请选择状态",
                          },
                          model: {
                            value: _vm.searchForm.state,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "state", $$v)
                            },
                            expression: "searchForm.state",
                          },
                        },
                        _vm._l(_vm.stateList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.fetchData(1)
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-search" }),
                          _vm._v(" 搜索"),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-table",
            { attrs: { stripe: "", data: _vm.listData, border: "" } },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "角色", width: "250" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "user_num", label: "用户数量", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "applys", label: "授权应用" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.applys, function (item) {
                        return _c(
                          "el-tag",
                          { key: item.id, attrs: { type: "primary" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.app_name) +
                                "\n          "
                            ),
                          ]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "状态", width: "140", prop: "state" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("el-switch", {
                            staticStyle: { display: "block" },
                            attrs: {
                              "active-color": "#13ce66",
                              "active-text": "启用",
                              "inactive-text": "禁用",
                              "active-value": 1,
                              "inactive-value": 2,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.switchChange(scope.row)
                              },
                            },
                            model: {
                              value: scope.row.state,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "state", $$v)
                              },
                              expression: "scope.row.state",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v(">\n        ")]
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "操作", width: "200" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { icon: "el-icon-edit", type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.tableEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "default",
                                icon: "el-icon-document-copy",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.copyRole(scope.row)
                                },
                              },
                            },
                            [_vm._v("复制")]
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [_vm._v(">\n        ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { float: "right", margin: "20px 0px" },
            attrs: {
              background: "",
              "pager-count": 5,
              "hide-on-single-page": "",
              "current-page": _vm.pagination.page,
              "page-sizes": [20, 50, 100],
              "page-size": _vm.pagination.limit,
              total: _vm.pagination.total,
              layout: "total,sizes,prev, pager, next",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "size-change": _vm.handlePageSizeChange,
              "current-change": _vm.handlePageChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "close-on-click-modal": !1,
            title: _vm.isEdit ? "编辑" : "新增",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "RoleForm",
              attrs: {
                model: _vm.dataForm,
                rules: _vm.rules,
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-input",
                    {
                      attrs: { placeholder: "请输入角色名称,不为空且请勿重复" },
                      model: {
                        value: _vm.dataForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataForm, "name", $$v)
                        },
                        expression: "dataForm.name",
                      },
                    },
                    [_c("template", { slot: "prepend" }, [_vm._v("角色")])],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-col",
                    [
                      _c(
                        "el-tabs",
                        {
                          staticStyle: {
                            "max-height": "56vh",
                            overflow: "auto",
                          },
                          model: {
                            value: _vm.activeName,
                            callback: function ($$v) {
                              _vm.activeName = $$v
                            },
                            expression: "activeName",
                          },
                        },
                        [
                          _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                label: "新授权渠道包",
                                name: "newFirst",
                              },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "allOption",
                                attrs: {
                                  "active-text": "全选",
                                  "inactive-text": "非全选",
                                },
                                on: { change: _vm.toggleAllByPackage },
                                model: {
                                  value: _vm.packageAll,
                                  callback: function ($$v) {
                                    _vm.packageAll = $$v
                                  },
                                  expression: "packageAll",
                                },
                              }),
                              _vm._v(" "),
                              !_vm.packageAll
                                ? _c(
                                    "el-checkbox-group",
                                    {
                                      model: {
                                        value:
                                          _vm.dataForm.permission.project_id,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.dataForm.permission,
                                            "project_id",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "dataForm.permission.project_id",
                                      },
                                    },
                                    _vm._l(
                                      _vm.packageSelectOptions,
                                      function (project, index) {
                                        return _c(
                                          "div",
                                          { key: index },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: {
                                                  label: project.id,
                                                  disabled: false,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.projectCheckboxChange(
                                                      project
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(project.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value:
                                                    _vm.dataForm.permission
                                                      .app_id,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.dataForm.permission,
                                                      "app_id",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dataForm.permission.app_id",
                                                },
                                              },
                                              _vm._l(
                                                project.children,
                                                function (app, appIndex) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: appIndex,
                                                      staticStyle: {
                                                        "padding-left": "30px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        {
                                                          attrs: {
                                                            label: app.app_id,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.appCheckboxChange(
                                                                app,
                                                                project
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(app.name)
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "el-checkbox-group",
                                                        {
                                                          model: {
                                                            value:
                                                              _vm.dataForm
                                                                .permission
                                                                .new_package_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.dataForm
                                                                  .permission,
                                                                "new_package_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "dataForm.permission.new_package_id",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                "padding-left":
                                                                  "30px",
                                                              },
                                                            },
                                                            _vm._l(
                                                              app.children,
                                                              function (
                                                                newPackage,
                                                                newPackageIndex
                                                              ) {
                                                                return _c(
                                                                  "el-checkbox",
                                                                  {
                                                                    key: newPackageIndex,
                                                                    attrs: {
                                                                      label:
                                                                        newPackage.id,
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.packageCheckboxChange(
                                                                            app,
                                                                            project
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        newPackage.name
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            {
                              attrs: { label: "授权推广渠道", name: "second" },
                            },
                            [
                              _c("el-switch", {
                                staticClass: "allOption",
                                attrs: {
                                  "active-text": "全选",
                                  "inactive-text": "非全选",
                                },
                                on: {
                                  change: function () {
                                    _vm.adChannelAll
                                      ? (_vm.dataForm.permission.ad_group = [
                                          "all",
                                        ])
                                      : (_vm.dataForm.permission.ad_group = [])
                                  },
                                },
                                model: {
                                  value: _vm.adChannelAll,
                                  callback: function ($$v) {
                                    _vm.adChannelAll = $$v
                                  },
                                  expression: "adChannelAll",
                                },
                              }),
                              _vm._v(" "),
                              !_vm.adChannelAll
                                ? _c("el-tree", {
                                    ref: "adChannelTree",
                                    attrs: {
                                      data: _vm.adChannelSelectOptions,
                                      "show-checkbox": "",
                                      "node-key": "id",
                                      "expand-on-click-node": false,
                                      "check-on-click-node": true,
                                      "default-checked-keys":
                                        _vm.dataForm.permission.ad_group,
                                      props: _vm.defaultProps,
                                      "set-checked-keys": "",
                                    },
                                    on: { check: _vm.checkOnClickNode },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "授权应用菜单", name: "third" } },
                            [
                              _c("el-tree", {
                                ref: "menuTree",
                                attrs: {
                                  data: _vm.menuSelectOptions,
                                  "show-checkbox": "",
                                  "node-key": "id",
                                  "expand-on-click-node": false,
                                  "check-on-click-node": true,
                                  props: _vm.defaultProps,
                                },
                                on: { check: _vm.checkOnClickNode },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-tab-pane",
                            { attrs: { label: "授权投放素材", name: "four" } },
                            [
                              _c("el-switch", {
                                staticClass: "allOption",
                                attrs: {
                                  "active-text": "全选",
                                  "inactive-text": "非全选",
                                },
                                on: {
                                  change: function () {
                                    _vm.catalogAll
                                      ? (_vm.dataForm.permission.local_material_dir =
                                          ["all"])
                                      : (_vm.dataForm.permission.local_material_dir =
                                          [])
                                  },
                                },
                                model: {
                                  value: _vm.catalogAll,
                                  callback: function ($$v) {
                                    _vm.catalogAll = $$v
                                  },
                                  expression: "catalogAll",
                                },
                              }),
                              _vm._v(" "),
                              !_vm.catalogAll
                                ? _c("el-tree", {
                                    ref: "catalogTree",
                                    attrs: {
                                      data: _vm.catalogOptions,
                                      "show-checkbox": "",
                                      "node-key": "id",
                                      "expand-on-click-node": false,
                                      "check-on-click-node": true,
                                      "default-checked-keys":
                                        _vm.dataForm.permission
                                          .local_material_dir,
                                      props: _vm.defaultProps,
                                      "set-checked-keys": "",
                                    },
                                    on: { check: _vm.checkOnClickNode },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-error" },
                  on: { click: _vm.resetForm },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-success" },
                  on: { click: _vm.onSave },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }